import { render } from "./IndustrialClientsForm.vue?vue&type=template&id=82ab8a60"
import script from "./IndustrialClientsForm.vue?vue&type=script&lang=js"
export * from "./IndustrialClientsForm.vue?vue&type=script&lang=js"

import "./IndustrialClientsForm.vue?vue&type=style&index=0&id=82ab8a60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__